module.exports = __webpack_public_path__ + "static/media/CERTIFICATE-KELAS-PINTAR-MINGGUAN-3.aeac5b06.png";